import classNames from 'classnames'
import React from 'react'

import styles from './SegmentRouteArrow.css'

export type ArrowPaths = {
  arrowDraw: string
  borderDraw: string
}

type SegmentRouteArrowProps = {
  isActive: boolean
  isInActive: boolean
  onClick: () => void
  paths: ArrowPaths
}

export const SegmentRouteArrow = ({
  isActive,
  isInActive,
  onClick,
  paths,
}: SegmentRouteArrowProps) => (
  <g
    className={classNames(styles.root, isActive && styles.active)}
    fillOpacity={isInActive ? 0.2 : undefined}
    onClick={onClick}
  >
    <path
      className={styles.arrowBorder}
      d={paths.borderDraw}
      fill="var(--colorCommonGrayF3)"
    />

    <path
      className={styles.arrow}
      d={paths.arrowDraw}
      fill={isActive ? 'var(--colorAppPrimary)' : 'var(--colorFontLighter)'}
    />
  </g>
)
